import { defineMessages } from 'react-intl';

export const errorBoundaryMessages: {
	title: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	description: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	title: {
		id: 'side-nav.chat-error.title',
		defaultMessage: "We're not sure what went wrong",
		description:
			'Title text displayed at the top of an error boundary message in the side navigation within the AI conversation interface when an unexpected error occurs. Shown as the heading of an error state component. The purpose is to immediately communicate to the user that an error occurred in the side navigation, even though the specific cause is unknown.',
	},
	description: {
		id: 'side-nav.chat-error.description',
		defaultMessage: 'Return to chat',
		description:
			'Button label or link text displayed in an error boundary message in the side navigation within the AI conversation interface that navigates back to the main chat view. Shown as clickable text or button label. When clicked, it returns the user to the main chat interface. The purpose is to provide users with a way to recover from the error and return to the functional chat view.',
	},
});
